"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Visa = exports.StyledLabel = exports.CountryName = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CountryName = exports.CountryName = _styledComponents["default"].p.withConfig({
  displayName: "Styled__CountryName",
  componentId: "sc-1r6ke0i-0"
})(["text-overflow:ellipsis;width:100%;font-size:16px;line-height:20px;", " ", ""], function (_ref) {
  var priority = _ref.priority;
  return priority && "\n    text-align: center;\n  ";
}, function (_ref2) {
  var theme = _ref2.theme,
    closed = _ref2.closed;
  return closed && "\n    color: ".concat(theme.colors.greyLight, "\n  ");
});
var Visa = exports.Visa = _styledComponents["default"].p.withConfig({
  displayName: "Styled__Visa",
  componentId: "sc-1r6ke0i-1"
})(["font-size:12px;line-height:16px;color:", ";"], function (_ref3) {
  var theme = _ref3.theme,
    noVisa = _ref3.noVisa,
    closed = _ref3.closed;
  return noVisa || closed ? theme.colors.greyLight : theme.colors.blue;
});
var StyledLabel = exports.StyledLabel = _styledComponents["default"].p.withConfig({
  displayName: "Styled__StyledLabel",
  componentId: "sc-1r6ke0i-2"
})(["margin:8px 0;color:#4d4d4d;font-size:12px;line-height:16px;"]);